import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation } from '@angular/core';
import { ResidentService } from '../../resident.service';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogRef, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import {ResidentGroupForCreationResponse, ResidentEditGroupForCreation} from '../../resident';
import { GroupNamefoundResponse, getGroupData, checkGroupName, checkGroupNotifyLevel } from '../../../../api';
import { ApiService } from '../../../../api.service';
import { RollbarService } from '../../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck,generateAlertMessage,AuthFailedMessage } from '../../../../app-general';
import { enumGroup_Type } from '../../../../app-settings';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { HostListener } from "@angular/core";
import { appsettings } from '../../../../app-settings';
@Component({
  selector: 'app-edit-resident-group',
  templateUrl: './edit-resident-group.component.html',
  providers: [ ResidentService ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-resident-group.component.scss']
})
export class EditresidentgroupComponent implements OnInit,OnDestroy {

  public residentGroupEditCreationForm : FormGroup;
  watcher: Subscription;
  columns: number = 3;
  EditGroupId;
  groupdetails;
  oldgroupname;
  residenteditgroupbool : boolean = true;
  groupresrowHeight = "67px";
  SiteId : "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<EditresidentgroupComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private residentService: ResidentService,@Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService,public dialog: MatDialog) {
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        
        if (change.mqAlias == 'xs') {
          this.columns = 2;
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 3;
        }         
        else {
          this.columns = 3;
        }
      }
    });
        this.EditGroupId = data.GroupId;
        this.oldgroupname = data.Groupname;
  }

  ngOnInit() 
  {
    this.onResize();
    this.getResidentGroup();
    this.residentGroupEditCreationForm = new FormGroup({
          groupname: new FormControl('',[Validators.required, Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
          description:new FormControl('',[Validators.required, Validators.maxLength(150), Validators.pattern(appsettings.Name_Pattern)])
     });
  }

  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.residentGroupEditCreationForm.controls).forEach(field => { // {1}
        const control = this.residentGroupEditCreationForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('add-staff.component.ts' + ' - handleInput() - ' + err.message);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {    
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)         
     if(isIEOrEdge == true)
     {       
       this.groupresrowHeight = "72.5px";
     }     
  }
  getResidentGroup(): void{
    try
    {
      var resgroupitem : getGroupData = {authKey: localStorage.getItem("Authkey")}
      this.apiService.getResidentGroup(resgroupitem).pipe(takeUntil(this._onDestroy))
      .subscribe((ResGroup : any[])=>{
        if(ResGroup["apiReturn"] == "Invalid Auth Key")
        {                  
            AuthFailedMessage(this.dialog,this.router);  
            return;       
        } 
        this.groupdetails = ResGroup["apiReturn"];        
      });
    }
    catch (err) {
      throw new Error('show-resident-group.component.ts' + ' - getResidentGroup() - ' + err.message);
    }
  }


  public onCloseCancel = () => {
    
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
  }
  public hasError = (controlName: string, errorName: string) =>{
    return this.residentGroupEditCreationForm.controls[controlName].hasError(errorName);
  }
  public createResidentGroup = (ResidentgroupFormValue) => {        
    try
    {  
      if(!SessionCheck(this.router))
      {
          this.thisDialogRef.close('Cancel');
          return;
      }
      (document.activeElement as HTMLTextAreaElement).blur();
      if (this.residentGroupEditCreationForm.valid && this.residenteditgroupbool) {         
        this.residenteditgroupbool = false;
        var groupnamefoundItem : checkGroupName = 
        {
          siteId:this.SiteId, 
          authKey: localStorage.getItem("Authkey"),
          groupType: 1, 
          newGroupName: ResidentgroupFormValue.groupname.toString(), 
          groupId: parseInt(this.EditGroupId) 
        }
        this.apiService.checkGroupName(groupnamefoundItem).pipe(takeUntil(this._onDestroy))
        .subscribe((apiresponse : GroupNamefoundResponse[])=>{        
          if(apiresponse.toString() == "not found")
          {
            this.checkGroupNotificationlevel(ResidentgroupFormValue);
          }
          else
          {
            this.residenteditgroupbool = true;
            generateAlertMessage(this.dialog, "Resident Group name '" + apiresponse[0].name + "' already exists");
            return;
          }
        });
      }
   }
  catch (err) {
    throw new Error('edit-resident-group.component.ts' + ' - createResidentGroup() - ' + err.message);
  }

  }
  
  checkGroupNotificationlevel(ResidentgroupFormValue)
  {
    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      }      
      if(this.oldgroupname != ResidentgroupFormValue.groupname.replace(/\s+/g, ' ').trim())
      {
        var groupfoundItem : checkGroupNotifyLevel = 
        {
          siteId:this.SiteId, 
          authKey: localStorage.getItem("Authkey"),
          resStaffType: parseInt(enumGroup_Type.Resident.toString()), 
          resStaffGroupId: this.EditGroupId.toString() 
        }
          this.apiService.checkGroupNotificationlevel(groupfoundItem).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : any[])=>{              
            if(apiresponse.length == 0)
            {
              this.updateResidentGroup(ResidentgroupFormValue);
            }
            else
            {
              this.residenteditgroupbool = true;
              generateAlertMessage(this.dialog, "Resident Group name '" + apiresponse[0].GroupName + "' is in escalation level,so please remove this group from escalation and try again.");
              return;
            }
        })
      }
      else
      {
        this.updateResidentGroup(ResidentgroupFormValue);
      }
    }
    catch (err) {
      throw new Error('edit-staff-group.component.ts' + ' - checkGroupNotificationlevel() - ' + err.message);
    }  
  }

  // edit Resident Group
  private updateResidentGroup = (ResidentgroupFormValue) => {
      try
      {
          let EditResidentgroup: ResidentEditGroupForCreation = {               
              authKey: localStorage.getItem("Authkey"),     
              groupname : ResidentgroupFormValue.groupname.replace(/\s+/g, ' ').trim(),
              description: ResidentgroupFormValue.description.replace(/\s+/g, ' ').trim(),
              groupId:  parseInt(this.EditGroupId)
          }
          this.residentService.updateResidentGroup(EditResidentgroup).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse : ResidentGroupForCreationResponse[])=>{                
              if(apiresponse["apiReturn"] == "Success")
              { 	
                this.residenteditgroupbool = false;
                generateAlertMessage(this.dialog, 'Resident group edited successfully.')                
              }
              else if(apiresponse["apiReturn"] == "Fail")
              {
                this.residenteditgroupbool = true;
                generateAlertMessage(this.dialog, 'Resident group edited failed.')               
              }
              else if(apiresponse["apiReturn"] == "Invalid Auth Key")
              {    
                  this.thisDialogRef.close('close');              
                  AuthFailedMessage(this.dialog,this.router);  
                  return;       
              } 
              this.thisDialogRef.close('Confirm');  
            });
        
          
      }
      catch (err) {
        throw new Error('edit-resident-group.component.ts' + ' - updateResidentGroup() - ' + err.message);
      }     
  }

 ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}
}
